

<div class="authincation h-100">
    <div class="container ">
        <div class="row justify-content-center h-100 align-items-center">
            <div class="col-md-6">
                <div class="error-page">
                    <div class="error-inner text-center">
                        <!-- <div class="dz-error" data-text="Success">Success</div> -->
                         @if(emailVerified){
                             <h2 class="error-head">Email verified successfully</h2>                             
                         }
                         @if(invalidEmail){
                            <h2 class="error-head">Email not verified. Please try to login to receive email verification mail</h2>
                        }
                        <a routerLink="/login" class="btn btn-secondary">Login</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>